import RestApiBuilder, { REST_API_ENDPOINTS } from '@utils/RestApiBuilder'
import { ApisauceInstance } from 'apisauce'
import useClientConfig from 'config/clients/useClientConfig'

/**
 * Expose all endponts for 'critical moments'.
 */
export default <SentimentCategory>(api: ApisauceInstance): REST_API_ENDPOINTS<SentimentCategory> => {
  return {
    ...RestApiBuilder<SentimentCategory>('sentiment-category', api)
  }
}